if(!customElements.get('custom-contact-form')){

  class CustomContactForm extends HTMLElement {
    constructor(){
      super();

      this.init();
    }

    init(){
      this.inputWrappers = this.querySelectorAll('.input-wrapper');
      this.inputs = this.querySelectorAll('input, textarea');
      this.inputs.forEach(item => {
        item.addEventListener('focus', this.focusOnInput.bind(this));
        item.addEventListener('focusout', this.focusOutOnInput.bind(this));
      });

      this.labels = this.querySelectorAll('.input-wrapper label');
      this.labels.forEach(item => {
        item.addEventListener('click', (e) => {
          if(e.currentTarget.closest('.input-wrapper').getAttribute('data-selected') != 'true'){
            const inputs = e.currentTarget.closest('.input-wrapper').querySelectorAll('input, textarea');
            inputs.forEach(item => {
              item.focus();
            })
          }
        })
      })
    }

    focusOnInput(e){
      this.inputWrappers.forEach(item => {
        var input = item.querySelector('textarea, input');
        if(input.value.trim() == '') item.setAttribute('data-selected', 'false');
      })

      var currentTarget = e.currentTarget;
      var currentTargetInputWrapper = currentTarget.closest('.input-wrapper');
      currentTargetInputWrapper.setAttribute('data-selected', 'true');
    }

    focusOutOnInput(){
      this.inputWrappers.forEach(item => {
        var input = item.querySelector('textarea, input');
        if(input.value.trim() == '') item.setAttribute('data-selected', 'false');
      })
    }
  }

  customElements.define('custom-contact-form', CustomContactForm);

}